// Dependencies
import React, { useContext } from "react";

import { CSSTransition } from 'react-transition-group';
import { CSSTransitionProps } from "react-transition-group/CSSTransition";

// Components
import { MinicartContext } from "../contexts/Minicart";
import { ActionButton, ShippingInfoNotice, SidebarFooterNoticesWrapper } from "./SidebarFooter";
import styled, { css } from "styled-components";
import Icon from "./Icon";


const ShopButton = styled(ActionButton)<any>(({ theme: { general: { transition, ...general }, components: { sidebarFooter: { actions: { button: styles } } } } }) => css`
		padding: ${styles.checkout.paddingBlock ?? styles.paddingBlock}em ${styles.checkout.paddingInline ?? styles.paddingInline}em;
		background: ${styles.checkout.background ?? styles.background};
		color: ${styles.checkout.textColor ?? styles.textColor};
		border: ${styles.checkout.borderWidth ?? styles.borderWidth}em solid ${styles.checkout.borderColor ?? styles.borderColor};
		border-radius: ${styles.checkout.borderRadius ?? styles.borderRadius}em;

		min-width: 100%;

		&:hover {
			border-color: ${styles.checkout.hoverBorderColor ?? styles.hoverBorderColor};
			color: ${styles.checkout.hoverTextColor ?? styles.hoverTextColor};
			background-color: ${styles.checkout.hoverBackground ?? styles.hoverBackground};
		}
`)

const SidebarContent = styled.div<any>(({ theme: { general: { transition, ...general }, components: { sidebarFooter: { actions: { button: styles } } } } }) => css`
				display: flex;
				flex-direction: column;
				padding: 3em clamp(1.35em, 5vw, 1.625em);
				text-align: center;
				align-items: center;

				svg {
						margin-bottom: 1.5em;
				}

				.wooptima-button {
						padding-left: 3em;
						padding-right: 3em;
				}

				h1 {
						font-size: 2.25em;
						margin: 0 0 0.5em;
						line-height: 1;
				}
				
				p {
						color: #6f6f6f;
						margin: 0 0 1.5em;
						font-size: 1em;
				}

				&.enter {
						&{
								transition: all ${transition.duration} ${transition.timingFunction};
								opacity: 0;
								transform: translateY(-100%);
						}
						&-active,
						&-done {
								opacity: 1;
								transform: translateY(0);
						}
				}
				
				&.exit {
						& {
								transition: all ${transition.duration} ${transition.timingFunction};
								opacity: 1;
								transform: translateY(0);
						}
						&-active,
						&-done {
								opacity: 0;
								transform: translateY(-100%);
						}
				}

`)

const SidebarEmptyWrapper = styled.div<any>(({ theme: { general: { transition, ...general }, components: { sidebarFooter: { actions: { button: styles } } } } }) => css`
		display: grid;
		align-content: space-between;
		width: 100%;
		height: 100%;

		svg[role=button] {
				width: 12em;
				height: 12em;
				color: #aaa;
		}

		/* ${SidebarFooterNoticesWrapper} {
				position: absolute;
				bottom: 0;
				left: 0;
		} */
`)

const SidebarEmpty = ({ className }: any) => {

		const [mounted, setMounted] = React.useState(false);

		React.useEffect(() => {
				requestAnimationFrame(() => setMounted(true));
				return () => setMounted(false);
		}, []);

		// Contexts
		const { itemsSubtotal, config, translations, theme } = useContext(MinicartContext);

		const transitionProps: CSSTransitionProps = React.useMemo(() => ({
				in: mounted,
				timeout: Number(theme.general.transition.duration.replace('ms', '')),
				mountOnEnter: true,
				unmountOnExit: true
		}), [theme.general.transition.duration, mounted])

		return (<>
				<SidebarEmptyWrapper>
						<CSSTransition {...transitionProps}>
								<SidebarContent>
										<Icon
												tabIndex={0}
												role="button"
												id="emptyCart"
										/>
										<h1>{translations?.cartEmpty.title}</h1>
										<p>{translations?.cartEmpty.subtitle}</p>
										<ShopButton href={config.links?.shop?.url}>{config.links?.shop?.label}</ShopButton>
								</SidebarContent>
						</CSSTransition>
						<CSSTransition {...transitionProps}>
								<SidebarFooterNoticesWrapper>
										<ShippingInfoNotice {...{ subtotal: itemsSubtotal, config, translations }} />
								</SidebarFooterNoticesWrapper>
						</CSSTransition>
				</SidebarEmptyWrapper>
		</>)
}

export default SidebarEmpty;